const STORAGE_KEY = "pendingOrgTarget";
const ORG_PATH = /^\/(\d+)(\/.*)?$/;

export function captureOrgTarget(route) {
    const match = ORG_PATH.exec(route.path);
    if (!match) return false;
    const path = match[2] && match[2] !== "/" ? match[2] : null;
    const target = {orgId: Number(match[1]), path, query: route.query, hash: route.hash};
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(target));
    } catch (error) {
        console.warn("orgFromUrl: target not stored", error);
    }
    return true;
}

export function hasPendingOrgTarget() {
    try {
        return sessionStorage.getItem(STORAGE_KEY) !== null;
    } catch (error) {
        return false;
    }
}

export function takePendingOrgTarget() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        return null;
    }
}
